import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  coursesOrderFilterMenuAscendantCurses: {
    id: "course-authoring.studio-home.courses.tab.order-filter-menu.ascendant-courses",
    defaultMessage: "Nombre A-Z",
  },
  coursesOrderFilterMenuDescendantCurses: {
    id: "course-authoring.studio-home.courses.tab.order-filter-menu.descendant-courses",
    defaultMessage: "Nombre Z-A",
  },
  coursesOrderFilterMenuNewestCurses: {
    id: "course-authoring.studio-home.courses.tab.order-filter-menu.newest-courses",
    defaultMessage: "Más recientes",
  },
  coursesOrderFilterMenuOldestCurses: {
    id: "course-authoring.studio-home.courses.tab.order-filter-menu.oldest-courses",
    defaultMessage: "Más antiguos",
  },
});

export default messages;
